@if (items().length) {
  <ul class="items">
    @for (item of items(); track item.id) {
      <li class="item">
        <div class="main">
          <div class="title">{{ item.title }}</div>
          @if (item.subtitle) {
            <div class="subtitle">{{ item.subtitle }}</div>
          }
          @for (line of item.details ?? []; track $index) {
            <div class="detail">{{ line }}</div>
          }
          <span class="status" [attr.data-kind]="item.statusKind">{{ item.status }}</span>
        </div>
        <dmb-progress-bar class="progress" variant="line" showLabel [value]="item.progress" />
        <div class="action">
          @if (item.link; as link) {
            <dmb-button variant="accent" type="button" (buttonClick)="open(item)">{{ link.label }}</dmb-button>
          }
        </div>
      </li>
    }
  </ul>
} @else {
  <div class="empty">{{ emptyText() }}</div>
}
